import React from "react";
import { FormattedMessage } from "react-intl";
import RatingAverage from "theme/modules/Reviews/RatingAverage";
import Link from "theme/components/atoms/Typography/Link";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import Mega from "theme/components/atoms/Typography/Heading/Mega";
import Stack from "theme/components/atoms/Layout/Stack";
import BodyFade from "theme/components/atoms/Typography/Body/BodyFade";
import { useLocation } from "react-router";
import { addReviewAnchorId } from "../PublishProductReview";

const LargeProductSynthesis = ({ product }) => {
  const location = useLocation();
  return (
    <>
      <div className="large-product-synthesis">
        <Stack size="2">
          <div className="large-product-synthesis__info">
            <div className="large-product-synthesis__item">
              {product.reviewsLayer.total > 0 ? (
                <Mega as="span">
                  {product.reviewsLayer.ratingAverage.toFixed(1)}
                </Mega>
              ) : null}
            </div>
            <div className="large-product-synthesis__item">
              {/* We remove the SEO properties here because they conflict with the rating average in the ProductName */}
              <RatingAverage noSeo={true} reviewsLayer={product.reviewsLayer} />
            </div>

            <div className="large-product-synthesis__item">
              <BodyFade>
                <LabelledIcon icon="user">
                  <FormattedMessage
                    id="modules.Reviews.LargeProductSynthesis.total"
                    defaultMessage="{total, plural, =0 {No review yet} =1 {1 Review} other {# Reviews}}"
                    values={{ total: product.reviewsLayer.total }}
                  />
                </LabelledIcon>
              </BodyFade>
            </div>
          </div>
          <div className="center">
            <Link
              buttonAppearance="primary"
              to={{ ...location, hash: `#${addReviewAnchorId}` }}
            >
              <FormattedMessage
                id="modules.Reviews.LargeProductSynthesis.addYourReview"
                defaultMessage="Add your review"
              />
            </Link>
          </div>
        </Stack>
      </div>
    </>
  );
};

export default LargeProductSynthesis;
